import React from 'react';
import Page from '../../containers/page';
import RouteComponent from '../../helpers/route';
import ListBuilder from '../../list-builder';
import Button from "../../form-builder/fields/button";

import moment from 'moment';
import Swal from "sweetalert2";

class Screen extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {
            total: 20,
            modules: [],
            items: [

            ],
            loaderSyncTransactions: false
        }
    }

    componentDidMount() {
        this._onLoad();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props[0].location.search != prevProps[0].location.search) {
            this._onLoad();
        }

    }
    sync = () => {
        this.setState({loaderSyncTransactions: true})
        this._api('sync-transactions', (data) => {
            const {result, status} = data
            if(status !== 200) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: result?.error || "Server error",
                })
            }
            this.setState({loaderSyncTransactions: false})
        }, (error) => {

            this.setState({loaderSyncTransactions: false})
        });
    }

    render() {
        let params = this._getParams();

        return (
            <div>
                <div className="section-title title-options">
                    <h1>{'Cura transactions'.translate(this.props.lang)}</h1>

                    <div className='buttons'>
                        <div className="ff-export">
                            <Button
                                loader={this.state.loaderSyncTransactions}
                                className="btn-primary"
                                onClick={() => this.sync()}
                            >
                                Run sync
                            </Button>
                        </div>


                    </div>

                </div>





                        <div>

                            <ListBuilder
                                tabs={false}
                                sort={true}

                                lang={this.props.lang}
                                loading={this.state.loading}
                                total={this.state.total}
                                showNumeration={false}
                                fields={[
                                    { type: 'text', name: 'idx', label: 'NO.'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'payoutId', label: 'Payout ID'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'transactionId', label: 'Transaction ID'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'type', label: 'Type'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'sourceOrderId', label: 'Source order id'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'fortnoxInvoiceNumber', label: 'Fortnox inv. num.'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'reconStatus', label: 'Status'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'reconReason', label: 'Reason'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'fortnoxBookkept', label: 'Booked'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'error', label: 'Error'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'tsCreated', label: 'Created'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'tsUpdated', label: 'Updated'.translate(this.props.lang), multilang: false, allowSort: true },

                                ]}
                                rawItems={this.state.items}
                                items={ this.state.items.map((item, idx) => {
                                    return {
                                        ...item,
                                        idx: idx + 1,
                                        error: item?.error?.message,
                                        fortnoxBookkept: item?.fortnoxBookkept === true ? 'Yes' : 'No',
                                        tsCreated: item.tsCreated ? `${moment.unix(item.tsCreated).format('YYYY-MM-DD HH:MM:ss')}` : '',
                                        tsUpdated: item.tsCreated ? `${moment.unix(item.tsCreated).format('YYYY-MM-DD HH:MM:ss')}` : ''
                                    }
                                })}

                                actions={
                                    [

                                    ]
                                }

                                params={params}
                                sortField={params.sortField}
                                sortType={params.sortType}
                                updateSort={this.updateSort}
                                updateParams={this.updateParams}
                                updateMultipleParams={this.updateMultipleParams}
                            ></ListBuilder>
                        </div>



            </div >
        )
    }
}

export default Page(Screen);
